module.exports = __webpack_public_path__ + "static/media/af.e711dbc8.svg";